<template>
  <div>
    <div>
      <div style="text-align:center;color:rgb(5,47,102);">
        <h6><b>INTIMATE A CLAIM</b></h6>
      </div>
      <div style="text-align:center;color:rgb(5,47,102)">
        <p>Please provide the claim details below</p>
      </div>
    </div>
    <div style="padding-left:20px;padding-right:20px">
        <div style="background-color:transparent;padding-bottom:10px">            
          <v-form ref="form">
            <v-row class="ma-0 pa-0"
            >
              <v-col
                class="ma-0 pa-0"
                cols="12"
                sm="3"
              >                   
                <v-text-field v-if="user.loggedIn"
                  label="First name"                        
                  v-model="user.data.first_name"                    
                  dense            
                  style="padding-right:5px"
                  outlined
                >  
                </v-text-field>
                <v-text-field v-else
                  label="First name"                        
                  v-model="custom.first_name"                       
                  dense            
                  style="padding-right:5px"
                  outlined
                >  
                </v-text-field>
              </v-col>
              <v-col 
                class="ma-0 pa-0"
                cols="12"
                sm="3"
              > 
                <v-text-field v-if="user.loggedIn"
                  label="Last name"
                  v-model="user.data.last_name"                     
                  dense                       
                  style="padding-right:5px"
                  outlined
                >  
                </v-text-field>
                <v-text-field v-else
                  label="Last name"
                  v-model="custom.last_name"                    
                  dense                       
                  style="padding-right:5px"
                  outlined
                >  
                </v-text-field>
              </v-col>
              <v-col
                class="ma-0 pa-0"
                cols="12"
                sm="3"
              >    
                <v-text-field v-if="user.loggedIn"
                  label="Email address"
                  v-model="user.data.email_address"                      
                  dense            
                  style="padding-right:5px" 
                  outlined
                >  
                </v-text-field>
                <v-text-field v-else
                  label="Email address"
                  v-model="custom.email_address"                    
                  dense            
                  style="padding-right:5px" 
                  outlined
                >  
                </v-text-field>
              </v-col>
              <v-col
                class="ma-0 pa-0"
                cols="12"
                sm="3"
              >   
                <v-text-field v-if="user.loggedIn"
                  label="Mobile number"
                  v-model="user.data.phone_number"                      
                  dense            
                  outlined
                >  
                </v-text-field>
                <v-text-field v-else
                  label="Mobile number"
                  v-model="custom.phone_number"                    
                  dense                   
                  outlined                 
                >  
                </v-text-field>
              </v-col>
            </v-row>  
            <v-row class="ma-0 pa-0"
            >
              <v-col
                class="ma-0 pa-0"
                cols="12"
                sm="3"
              >        
                <v-menu
                  :v-model="menu2"
                  :close-on-content-click="true"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="computedDateFormatted"
                      label="Date of Loss"
                      readonly
                      required
                      outlined
                      dense
                      :rules="[v => !!v || 'This is a required field']"
                      v-on="on"
                      style="padding-right:5px;"
                    ></v-text-field>
                  </template>
                  <v-date-picker 
                    v-model="date" 
                    no-title 
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>          
              </v-col>
              <v-col
                class="ma-0 pa-0"
                cols="12"
                sm="3"
              >                   
                <v-select             
                  :items="policy_types"
                  v-model="policy_type"
                  placeholder="Policy Type"
                  item-text="text"
                  item-value="value"
                  dense
                  @change="policyChanged"
                  return-object
                  required
                  :rules="[v => !!v || 'This is a required field']"      
                  outlined        
                  style="padding-right:5px;"        
                >
                </v-select>
              </v-col>
              <v-col 
                class="ma-0 pa-0"
                cols="12"
                sm="3"
              > 
                <v-select             
                  :items="policy_list"
                  v-model="policy_number"
                  placeholder="Policy Number"
                  item-text="text"
                  item-value="value"
                  dense
                  @change="policyNumberChanged"
                  return-object
                  required
                  :rules="[v => !!v || 'This is a required field']"      
                  outlined         
                  style="padding-right:5px;"        
                >
                </v-select>
              </v-col>
              <v-col
                class="ma-0 pa-0"
                cols="12"
                sm="3"
              >    
                <v-text-field
                  label="Policy description"
                  v-model="description"                    
                  dense            
                  style="padding-right:5px" 
                  outlined
                  readonly
                >  
                </v-text-field>
              </v-col>
            </v-row>
            <v-text-field
              label="Claim narration"
              v-model="complaint"                    
              outlined  
            >  
            </v-text-field>
              
          </v-form>                     
          <v-btn
            text
            @click="submit"
            outlined
          >
            Submit
          </v-btn>
          <v-btn 
            outlined
            style="margin-left:5px"
            text
            @click="components.bottom_sheet.is_open = false"
          >
            Cancel
          </v-btn>
        </div>
      </div>
  </div>
</template>
<script>
  import { mapGetters } from "vuex";
  import axios from "axios";

  //const URL = "http://35.242.182.168/services/complaintsComplimentsApi/public/complaint-compliments";
  const URL = `http://35.242.182.168/microservices/CustomerCareApi/public/customer-care/customer-claims-requests`;
  const GET_POLICIES_URL = "http://139.59.131.242:4000/client/allClientPolicies";
  

  export default {
    name: 'ClaimIntimation',
    data: () => ({
      custom: {
        first_name: '',
        last_name: '',
        email_address: '',
        phone_number: '',
      },
      complaint: '',
      policy_type: '',
      policy_number: '',
      policy_types: [
        { text: 'Motor Comprehensive Insurance', value: '1' },
        { text: 'Motor Full Third Party Insurance', value: '2' },
        { text: 'Overseas Travel Insurance', value: '3' },
        { text: 'Muende Bwino Personal Cover', value: '4' },
        { text: 'House Owners Insurance', value: '5' }
      ],
      policy_list: [],
      description: '',
      policies: null,
      date_of_loss: '',
      date: new Date().toISOString().substr(0, 10),
      menu2: false,
    }),
    methods: {
      closeSheet(){
        this.components.bottom_sheet.is_open=false;
        this.components.bottom_sheet.option_index=0;
      },
      showAlert(){
        this.components.bootstrap_alert.dismissCountDown = this.components.bootstrap_alert.dismissSecs;
        this.components.bootstrap_alert.variant = 'success';

        if (this.components.bottom_sheet.option_index==4){
          this.components.bootstrap_alert.alert_text = 'Complaint submission successful!';
        }else{
          this.components.bootstrap_alert.alert_text = 'Compliment submission successful!';
        }
      },
      policyChanged(){
        this.description = '';
        const client = {
          id: this.user.data.client_id
        }

        axios
        .get(GET_POLICIES_URL, { params:client })
        .then(response => {
          if (response.status == 200){
            this.policies = response.data;
            this.policy_list = [];
            var policy = null;
            var i;

            if (this.policy_type.value == 1){              
              for (i = 0; i < this.policies.comprehensive.length; i++) {
                policy = {
                  text: this.policies.comprehensive[i].transaction_number,
                  value: this.policies.comprehensive[i].id
                }
      
                this.policy_list.push(policy);
              }
            }
            if (this.policy_type.value == 2){              
              for (i = 0; i < this.policies.thirdparty.length; i++) {
                policy = {
                  text: this.policies.thirdparty[i].transaction_number,
                  value: this.policies.thirdparty[i].id
                }
      
                this.policy_list.push(policy);
              }
            }
            if (this.policy_type.value == 3){              
              for (i = 0; i < this.policies.oti.length; i++) {
                policy = {
                  text: this.policies.oti[i].transaction_number,
                  value: this.policies.oti[i].id
                }
      
                this.policy_list.push(policy);
              }
            }
            if (this.policy_type.value == 4){              
              for (i = 0; i < this.policies.muendebwino.length; i++) {
                policy = {
                  text: this.policies.muendebwino[i].transaction_number,
                  value: this.policies.muendebwino[i].id
                }
      
                this.policy_list.push(policy);
              }
            }
            if (this.policy_type.value == 5){              
              for (i = 0; i < this.policies.houseowners.length; i++) {
                policy = {
                  text: this.policies.houseowners[i].transaction_number,
                  value: this.policies.houseowners[i].id
                }
      
                this.policy_list.push(policy);
              }
            }            
          }
        })
        .catch(error => {
          console.log(error);
        }); 
      },
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      policyNumberChanged(){
        var i;
        if (this.policy_type.value == 1){

          for (i = 0; i < this.policies.comprehensive.length; i++) {
            if (this.policies.comprehensive[i].transaction_number == this.policy_number.text){
              this.description = 'Policy for ' + this.policies.comprehensive[i].vehicles[0].vehicle_reg_number;
            }
          }
        }
        if (this.policy_type.value == 2){

          for (i = 0; i < this.policies.thirdparty.length; i++) {
            if (this.policies.thirdparty[i].transaction_number == this.policy_number.text){
              this.description = 'Policy for ' + this.policies.thirdparty[i].vehicles[0].vehicle_reg_number;
            }
          }
        }
        if (this.policy_type.value == 3){

          for (i = 0; i < this.policies.oti.length; i++) {
            if (this.policies.oti[i].transaction_number == this.policy_number.text){
              this.description = 'Policy for ' + this.policies.oti[i].destination + ' trip';
            }
          }
        }
        if (this.policy_type.value == 4){

          for (i = 0; i < this.policies.muendebwino.length; i++) {
            if (this.policies.muendebwino[i].transaction_number == this.policy_number.text){
              this.description = 'Policy for ' + this.policies.muendebwino[i].num_of_travellers + ' traveller(s) for ' + this.policies.muendebwino[i].num_of_months + ' month(s)';
            }
          }
        }
        if (this.policy_type.value == 5){

          for (i = 0; i < this.policies.houseowners.length; i++) {
            if (this.policies.houseowners[i].transaction_number == this.policy_number.text){
              this.description = 'House no' + this.policies.houseowners[i].houses[0].house_address;
            }
          }
        }
      },
      submit() {
        if (this.$refs.form.validate()){
          this.loading = true;

          /*var first_name = "";
          var last_name = "";
          var full_name = "";
          var email_address = "";
          var dial_code = "";
          var phone_number = "";

          if (this.user.loggedIn){
            first_name = this.user.data.first_name;
            last_name = this.user.data.last_name;
            full_name = this.user.data.first_name + " " + this.user.data.last_name;
            email_address = this.user.data.email_address;
            phone_number = this.user.data.phone_number;
          }else{
            first_name = this.custom.first_name;
            last_name = this.custom.last_name;
            full_name = this.custom.first_name + " " + this.custom.last_name;
            email_address = this.custom.email_address;
            phone_number = this.custom.phone_number;
          }*/

         /* var n = phone_number.length;
          var mobile_number = "";

          if (n > 12){
            dial_code = phone_number.substring(0,4);
            mobile_number = phone_number.substring(4,n);
          }*/

          var data = {
            /*first_name: first_name,
            last_name: last_name,
            email: email_address,
            dial_code: dial_code,
            phone_number: mobile_number,
            channel: 'Website',
            insured: full_name,
            date_of_loss: "2019-12-19",
            policy_type: this.policy_type.text,
            policy_number: this.policy_number.text,
            claims_narration: this.description*/
            first_name: "Luse",
            last_name: "Kasanda",
            other_names: "Luke",
            title: "Mr",
            gender: "MALE",
            email: "luke@picz.co.zm",
            dial_code: "+260",
            phone_number: "973674534",
            residential_address: "Salama Park",
            postal_address: "P.O. Box 35432 Lusaka",
            channel: "WEBSITE",
            start_date: "2019-03-29",
            end_date: "2020-03-12",
            policy_number: "305/HO/2019/13472"         
          }

          console.log(data);

          const headers = {
            'Content-Type': 'application/json',
            'Authorisation': 'Oy8JBJ71LLA97RKZ8R7yGO9aWo1MN4Go'
          }  

          axios
          .post(URL, data, headers )
          .then(response => {              
              console.log(response);
              //display alert
              this.showAlert();
          })
          .catch(error => {
              console.log(error);
          });     
          
          //close bottom sheet
          //this.closeSheet();
          
        }
      },
    },
    computed: {
      ...mapGetters({
        user: "user",
        components: "components"
      }),
      computedDateFormatted () {
        return this.formatDate(this.date)
      },
    },
    updated() {
      
    },
    created(){
      
    }
  }
</script>
